<div class="container">
  <mat-card>
    <form [formGroup]="settleCashForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
            <input matInput required formControlName="office" />
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Teller Name' | translate }}</mat-label>
            <input matInput required formControlName="tellerName" />
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Cashier' | translate }}</mat-label>
            <input matInput required formControlName="cashier" />
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Assignment Period' | translate }}</mat-label>
            <input matInput formControlName="assignmentPeriod" />
          </mat-form-field>

          <mat-form-field class="flex-48" (click)="cashDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="cashDatePicker"
              required
              formControlName="txnDate"
            />
            <mat-datepicker-toggle matSuffix [for]="cashDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #cashDatePicker></mat-datepicker>
            @if (settleCashForm.controls.txnDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Currency' | translate }}</mat-label>
            <mat-select required formControlName="currencyCode">
              @for (currency of cashierData.currencyOptions; track currency) {
                <mat-option [value]="currency.code">
                  {{ currency.name }}
                </mat-option>
              }
            </mat-select>
            @if (settleCashForm.controls.currencyCode.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Currency' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Amount' | translate }}</mat-label>
            <input matInput required formControlName="txnAmount" />
            @if (settleCashForm.controls.txnAmount.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Notes/Comments' | translate }}</mat-label>
            <input matInput required formControlName="txnNote" />
            @if (settleCashForm.controls.txnNote.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Notes/Comments' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!settleCashForm.valid"
          *LOSxHasPermission="'SETTLECASHFROMCASHIER_TELLER'"
        >
          {{ 'labels.buttons.Settle Cash' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
